export default __webpack_public_path__ + "static/media/blacknut.689b3065.png";